<template>
    <div>
        <b-modal id="edit_password_modal" @ok="edit_password">
            <template slot="modal-title">Change your password</template>
            <form ref="edit_password_form">
                <b-form-group
                        label="Password"
                        label-for="password"
                        invalid-feedback="Password is invalid. (check the requirements below)">
                    <b-form-input
                            id="password"
                            type="password"
                            :state="validate_password"
                            v-model="password"
                            autofocus
                            required/>
                </b-form-group>
                <b-form-group
                        label="Repeat password"
                        label-for="passwordRepeat"
                        invalid-feedback="Password are not the same or does not meet the requirements.">
                    <b-form-input
                            id="passwordRepeat"
                            type="password"
                            :state="validate_password_again"
                            v-model="passwordRepeat"
                            required/>
                </b-form-group>
                <b-card-header>Requirements</b-card-header>
                <b-card-body>
                    <div>
                        <v-icon class="successfulRequirement" v-if="password_has_number">mdi-check-circle-outline
                        </v-icon>
                        <v-icon class="failedRequirement" v-else>mdi-alert-rhombus-outline</v-icon>
                        <span> contains at least 1 number (0-9)</span>
                    </div>
                    <div>
                        <v-icon class="successfulRequirement" v-if="password_has_uppercase">mdi-check-circle-outline
                        </v-icon>
                        <v-icon class="failedRequirement" v-else>mdi-alert-rhombus-outline</v-icon>
                        <span> contains at least 1 uppercase letter</span>
                    </div>
                    <div>
                        <v-icon class="successfulRequirement" v-if="password_has_lowercase">mdi-check-circle-outline
                        </v-icon>
                        <v-icon class="failedRequirement" v-else>mdi-alert-rhombus-outline</v-icon>
                        <span> contains at least 1 lowercase</span>
                    </div>
                    <div>
                        <v-icon class="successfulRequirement" v-if="password_has_special_character">
                            mdi-check-circle-outline
                        </v-icon>
                        <v-icon class="failedRequirement" v-else>mdi-alert-rhombus-outline</v-icon>
                        <span> contains at least 1 special character</span>
                    </div>
                    <div>
                        <v-icon class="successfulRequirement" v-if="password_has_length">mdi-check-circle-outline
                        </v-icon>
                        <v-icon class="failedRequirement" v-else>mdi-alert-rhombus-outline</v-icon>
                        <span> is 8-4096 characters long with no spaces</span>
                    </div>
                </b-card-body>
            </form>
        </b-modal>
    </div>
</template>

<script>
    import AccountRepository from '../../repositories/account.repository';
    import UserRepository from '../../repositories/user.repository';

    export default {
        props: {
            user_id: {
                type: Number,
                default: -1
            }
        },
        data() {
            return {
                password: '',
                passwordRepeat: '',
            }
        },
        methods: {
            checkFields() {
                if (AccountRepository.validate.password(this.password) === false) return false;
                if (AccountRepository.validate.passwordRepeat(this.password, this.passwordRepeat) === false) return false;
                return true;
            },
            edit_password(modal) {
                if (this.$refs.edit_password_form.checkValidity() && this.checkFields()) {
                    this.$emit('show-loading-pop-up', 'Saving the password of the user.');
                    let data = {user_id: this.user_id, password: this.password};
                    UserRepository.editPassword(data).then(res => {
                        // Notify the user.
                        this.$emit('reset-loading-pop-up');
                        this.$bvToast.toast(`Password successfully edited.`, {
                            title: `password edited.`,
                            variant: 'success',
                            solid: true
                        });
                        this.password = '';
                        this.passwordRepeat = '';
                    }).catch(error => {
                        this.$emit('reset-loading-pop-up');
                        if (error.response.status === 422) {
                            console.error("Errorcode: " + error.response.status + " Type: " + error.response.statusText + " \n details:" + error.response.data['hydra:description']);
                            this.$bvToast.toast('Looks like something went wrong while validating the new password. Check the value\'s of all the fields', {
                                title: `password edit error.`,
                                variant: 'danger',
                                solid: true
                            });
                        } else {
                            console.error("Errorcode: " + error.response.status + " Type: " + error.response.statusText);
                            this.$bvToast.toast('Looks like something went wrong on the server while editing the password.', {
                                title: `Password edit error.`,
                                variant: 'danger',
                                solid: true
                            });
                        }
                    });
                } else {
                    modal.preventDefault();
                }
            }
        },
        computed: {
            validate_password() {
                return AccountRepository.validate.password(this.password);
            },
            validate_password_again() {
                return AccountRepository.validate.passwordRepeat(this.password, this.passwordRepeat);
            },
            password_has_number() {
                return AccountRepository.validate.passwordHasNumber(this.password);
            },
            password_has_uppercase() {
                return AccountRepository.validate.passwordHasUppercase(this.password);
            },
            password_has_lowercase() {
                return AccountRepository.validate.passwordHasLowercase(this.password);
            },
            password_has_special_character() {
                return AccountRepository.validate.passwordHasSpecialCharacter(this.password);
            },
            password_has_length() {
                return AccountRepository.validate.passwordHasLength(this.password);
            },

        }
    }
</script>

<style>

    .failedRequirement {
        color: red !important;
    }

    .successfulRequirement {
        color: green !important;
    }

</style>
